import { render, staticRenderFns } from "./MemberInfoNew.vue?vue&type=template&id=31b4a9b0&scoped=true&"
import script from "./MemberInfoNew.vue?vue&type=script&lang=js&"
export * from "./MemberInfoNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberInfoNew.vue?vue&type=style&index=0&id=31b4a9b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b4a9b0",
  null
  
)

export default component.exports